import { useState, useEffect } from 'react';
import axios from 'axios';
import { currentApi } from '../model/currentApi';

interface MaintenanceResponse {
  onMaintenance: boolean;
}

export const useMaintenanceStatus = () => {
  const [isOnMaintenance, setIsOnMaintenance] = useState<boolean|null>(null);


  const checkMaintenanceStatus = async () => {
    try {
      const response = await axios.get<MaintenanceResponse>(`${currentApi.value}/status.json?r=${Date.now()}`);
      setIsOnMaintenance(response.data.onMaintenance);
    } catch (err) {
      console.error('Failed to fetch maintenance status:', err);

    }
  };

  useEffect(() => {
    checkMaintenanceStatus();


    const interval = setInterval(checkMaintenanceStatus, 1000 * 30);


    return () => clearInterval(interval);
  }, []);

  return { isOnMaintenance };
};
